// extracted by mini-css-extract-plugin
export default {"spacing":"ntq8dOow+CpGfwq8FqQTwQ==","truncateMultipleLines":"XN8F1gu+XgWfN5trHV626w==","truncateLine":"UYXuUJrcsVJ9RwuePTVE6w=="};